// import React, { useState, useEffect } from 'react';
// import {
//     Dialog, DialogTitle, DialogContent, DialogActions, Button,
//     Grid, TextField, FormControl, InputLabel, Select, MenuItem,
//     CircularProgress, Box
// } from '@mui/material';
// import SaveIcon from '@mui/icons-material/Save';

// export default function FiltroDeVendas({ onSearch, isLoading }) {

//     const [formData, setFormData] = useState({
//         data_inicio: '',
//         data_fim: '',
//         incluir_produtos: 'N',
//         operador: '',
//     });


//     const handleChange = (e) => {
//         setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));
//     };

//     const handleSubmit = (e) => {
//         e.preventDefault();
//         onSearch(formData);
//     };

//     return (

//         <Box
//             component="form"
//             onSubmit={handleSubmit}
//             sx={{ width: '100%' }}

//         >
//             <DialogTitle>Gerar relatório de vendas</DialogTitle>
//             <DialogContent>
//                 <Grid container spacing={2} sx={{ mt: 1 }}>
//                     <Grid item size={{ sx: 1, sm: 12, md: 4, lg: 3, xl: 1, xs: 12 }}>
//                         <InputLabel>Data início</InputLabel>
//                         <TextField type='date'
//                             fullWidth
//                             name="data_inicio"
//                             value={formData.data_inicio}
//                             onChange={handleChange}
//                             required
//                         />
//                     </Grid>
//                     <Grid item size={{ sx: 1, sm: 12, md: 4, lg: 3, xl: 1, xs: 12 }}>
//                         <InputLabel>Data final</InputLabel>
//                         <TextField 
//                         fullWidth 
//                         type='date'
//                          name="data_fim" value={formData.data_fim} onChange={handleChange} required />
//                     </Grid>
//                     <Grid item size={{ sx: 1, sm: 12, md: 4, lg: 3, xl: 1, xs: 12 }}>
//                         <InputLabel>Incluir produtos </InputLabel>
//                         <FormControl fullWidth>
//                             <Select sx={{ backgroundColor: 'white' }} name="incluir_produtos" value={formData.incluir_produtos} onChange={handleChange} >
//                                 <MenuItem value="S">Sim</MenuItem>
//                                 <MenuItem value="N">Não</MenuItem>
//                             </Select>
//                         </FormControl>
//                     </Grid>
//                     <Grid item size={{ sx: 1, sm: 12, md: 4, lg: 3, xl: 1, xs: 12 }}>
//                         <InputLabel>Operador</InputLabel>
//                         <FormControl fullWidth>
//                             <Select sx={{ backgroundColor: 'white' }} name="operador" value={formData.operador} onChange={handleChange} >
//                                 <MenuItem value="cielo">Cielo</MenuItem>
//                                 <MenuItem value="stone">Stone</MenuItem>
//                                 <MenuItem value="getnet">GetNet</MenuItem>
//                             </Select>
//                         </FormControl>
//                     </Grid>
//                 </Grid>
//             </DialogContent>
//             <DialogActions>
//                 <Button type="submit" variant="outlined" startIcon={isLoading ? <CircularProgress size={20} color="inherit" /> : <SaveIcon />} disabled={isLoading}>
//                     Gerar relatório
//                 </Button>
//             </DialogActions>
//         </Box>

//     );
// }


import React, { useState } from 'react';
import {
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Grid,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    CircularProgress,
    Box,
    TextField
} from '@mui/material';
import SaveIcon from '@mui/icons-material/Save';

import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import 'dayjs/locale/pt-br';

export default function FiltroDeVendas({ onSearch, isLoading }) {
    const [formData, setFormData] = useState({
        data_inicio: null,
        data_fim: null,
        incluir_produtos: 'N',
        operador: '',
    });

    const handleChange = (e) => {
        setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));
    };

    const handleDateChange = (name, newValue) => {
        setFormData(prev => ({ ...prev, [name]: newValue }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        onSearch(formData);
    };

    return (
        <Box
            component="form"
            onSubmit={handleSubmit}
            sx={{ width: '100%' }}
        >
            <DialogTitle>Gerar relatório de vendas</DialogTitle>
            <DialogContent>
                <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="pt-br">
                    <Grid container spacing={2} sx={{ mt: 1 }}>
                        <Grid item size={{ sx: 1, sm: 12, md: 4, lg: 3, xl: 1, xs: 12 }}>
                            <InputLabel>Data início</InputLabel>
                            <DatePicker
                                sx={{ width: '100%' }}
                                value={formData.data_inicio}
                                onChange={(newValue) => handleDateChange('data_inicio', newValue)}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        fullWidth
                                        required
                                        sx={{ height: '56px' }} // altura padrão do TextField
                                    />
                                )}
                            />
                        </Grid>

                        <Grid item size={{ sx: 1, sm: 12, md: 4, lg: 3, xl: 1, xs: 12 }}>
                            <InputLabel>Data fim</InputLabel>
                            <DatePicker
                                sx={{ width: '100%' }}
                                value={formData.data_fim}
                                onChange={(newValue) => handleDateChange('data_fim', newValue)}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        fullWidth
                                        required
                                        sx={{ height: '56px' }}
                                    />
                                )}
                            />
                        </Grid>

                        <Grid item size={{ sx: 1, sm: 12, md: 4, lg: 3, xl: 1, xs: 12 }}>
                            <InputLabel>Incluir produtos</InputLabel>
                            <FormControl fullWidth sx={{ height: '56px' }}>
                                <Select
                                    sx={{ height: '100%', backgroundColor: 'white' }}
                                    name="incluir_produtos"
                                    value={formData.incluir_produtos}
                                    onChange={handleChange}
                                >
                                    <MenuItem value="S">Sim</MenuItem>
                                    <MenuItem value="N">Não</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>

                        <Grid item size={{ sx: 1, sm: 12, md: 4, lg: 3, xl: 1, xs: 12 }}>
                            <InputLabel>Operador</InputLabel>
                            <FormControl fullWidth sx={{ height: '56px' }}>
                                <Select
                                    sx={{ height: '100%', backgroundColor: 'white' }}
                                    name="operador"
                                    value={formData.operador}
                                    onChange={handleChange}
                                >
                                    <MenuItem value="cielo">Cielo</MenuItem>
                                    <MenuItem value="stone">Stone</MenuItem>
                                    <MenuItem value="getnet">GetNet</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid>
                </LocalizationProvider>
            </DialogContent>

            <DialogActions>
                <Button
                    type="submit"
                    variant="outlined"
                    startIcon={isLoading ? <CircularProgress size={20} color="inherit" /> : <SaveIcon />}
                    disabled={isLoading}
                >
                    Gerar relatório
                </Button>
            </DialogActions>
        </Box>
    );
}
